import createCachedSelector from 're-reselect'
import { emptyObj } from 'util/objects'
import { selectProduct } from '../selectProduct'
import { byProductCacheKey } from './byProductCacheKey'

export const selectProductFeatures = createCachedSelector(
  selectProduct,
  product => product?.features || emptyObj
)(byProductCacheKey)
